import { render } from "./serviceDropdown.vue?vue&type=template&id=79afcbbf&scoped=true"
import script from "./serviceDropdown.vue?vue&type=script&lang=js"
export * from "./serviceDropdown.vue?vue&type=script&lang=js"

import "./serviceDropdown.vue?vue&type=style&index=0&id=79afcbbf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79afcbbf"]])

export default __exports__